<template>
	<toolbar-search-view placeholder="Brugertype" />
</template>

<script>
	export default {
		
	}
</script>

<style lang="scss" scoped>

</style>
